export default __webpack_public_path__ + "static/media/Photo04.99752e01.jpg";